/**
 * The expense routes the web and the phone both call (T3226): the mileage
 * reads and the two receipt routes. One builder each, encoding every id.
 * 🔨 Relative to the API's own root, so no path repeats the base's `/api`.
 */
export const EXPENSES_PATH = '/expenses';
/** Decision 1187: the Documents Inbox's unfiled receipts, the reader's own, in arrival order. */
export const EXPENSE_RECEIPTS_PATH = `${EXPENSES_PATH}/receipts`;

/** The person's own drive events of one day (decisions 1315, 7920). */
export function mileageEventsPath(day: string): string {
  return `${EXPENSES_PATH}/mileage/events?on=${encodeURIComponent(day)}`;
}

/** The miles the map reads for one drive (decision 2963). */
export function mileageDistancePath(eventId: string, day: string): string {
  return `${EXPENSES_PATH}/mileage-distance?eventId=${encodeURIComponent(eventId)}&on=${encodeURIComponent(day)}`;
}

/** What an uploaded receipt reads as: its date, merchant and total (decisions 1188, 7771). */
export function receiptReadingPath(fileId: string): string {
  return `${EXPENSE_RECEIPTS_PATH}/${encodeURIComponent(fileId)}/reading`;
}

/**
 * The drop zone's route (decisions 1475, 7771). 🔨 Behind a queued photo on the
 * phone the file is named by its `@write:` reference, which the queue swaps for
 * the File's id, so that reference is never encoded.
 */
export function receiptScanPath(fileIdOrRef: string): string {
  const segment = fileIdOrRef.startsWith('@write:') ? fileIdOrRef : encodeURIComponent(fileIdOrRef);
  return `${EXPENSE_RECEIPTS_PATH}/${segment}/scan`;
}
